import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import flyerPrintTemplateStrings from './contextualStrings';
import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';
import getConfig from '../../../../../../../../util/config';
import { ALL_PHOTOS_MODE } from '../../../../../../../../constants/album-folder';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplateSellPhotosJoinCode = ({ albumFolder, account }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  const watermarkedGalleryUrl =
    albumFolder.all_photos_mode === ALL_PHOTOS_MODE.PUBLIC &&
    `${getConfig().app.baseUrl}/s/all-photos-access/${albumFolder.id}`;

  let mainUrl;
  if (watermarkedGalleryUrl && !albumFolder.joins_enabled) {
    mainUrl = watermarkedGalleryUrl;
  } else {
    mainUrl = albumFolder.onboarding_short_url;
  }

  return (
    <Fragment>
      <p className="marketing-material-flyer-main-copy text-light">
        <strong>{account.organization_name}</strong>{' '}
        <ContextualString
          id="sellPhotosMainCopy"
          defaultMessage="has partnered with Waldo to deliver your photo proofs! You will receive your proofs directly to your phone, where you can order and have your prints shipped directly to you!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={flyerPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>

      <p
        className="text-uppercase"
        style={{
          color: '#0d84fe',
          position: 'absolute',
          top: '64%',
          left: '16.5%',
          margin: 0,
          fontWeight: 600,
          fontSize: '2.5vw',
          lineHeight: 1,
          letterSpacing: '-.02em',
        }}
      >
        {albumFolder.join_code}
      </p>

      <div
        style={{
          top: '50.7%',
          right: '12%',
        }}
        className="marketing-material-flyer-qrcode-secondary"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: mainUrl,
            albumFolder,
          })}
          size={width * 0.22 ?? 500}
        />
      </div>

      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_FLYER_SELL_PHOTOS_JOIN_CODE_1.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplateSellPhotosJoinCode.propTypes = propTypes;

export default FlyerPrintTemplateSellPhotosJoinCode;
